module.exports = __webpack_public_path__ + "static/img/product03_03.3160173.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product03/product03_03.png
// module id = 0C6I
// module chunks = 1